module.exports = __webpack_public_path__ + "static/media/showcase_phone.e0542141.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/showcase_phone.png
// module id = 1636
// module chunks = 0